import React from "react";
import { Input } from "reactstrap";
import './newFIlters.css'
import CustomButton1 from "../Buttons/CustomButton1";
import FilterDropdown from "./FilterDropdown";

export default function TableFilter({ filtersConfig = [], setFilters, handleSave, handleCancel, filters, timeFilter }) {
    const handleFilterChange = (key, value) => {
        const newValue = value === "Select" ? "" : value;
        setFilters((prev) => ({ ...prev, [key]: newValue }));
    };

    const filterStyles = {
        alignSelf: "end",
        height: "40px",
        width: "155px",
    };

    const handleInputChange = (e, key) => {
        // setFilters((prev) => ({ ...prev, [key]: e.target.value }));

        if(key=='month'){
            setFilters({
                ...filters,
                week: '',
                date: '',
                starting: '',
                ending: '',
                month:e.target.value
            })
        }
        else if(key=='week'){
            setFilters({
                ...filters,
                date: '',
                starting: '',
                ending: '',
                month:'',
                week:e.target.value
            })
        }
        else if(key=='date'){
            setFilters({
                ...filters,
                week: '',
                starting: '',
                ending: '',
                month:'',
                date:e.target.value
            })
        }
    };

    return (
        <>
            <div className="w-full " style={{ width: 'max-content', }}>

                <div className="d-flex gap-3 flex-column px-3 py-4 border rounded position-absolute  z-10" style={{ zIndex: 4, backgroundColor: '#fff', top: '38px', right: '0' }}>

                    {filtersConfig?.map(({ key, options, placeholder }) => (
                        <FilterDropdown
                            key={key}
                            options={options}
                            placeholder={placeholder}
                            onSelect={(value) => handleFilterChange(key, value)}
                            stylings={filterStyles}
                            filters={filters}
                            filtersKey={key}
                        />
                    ))}
                    {filters.selectDate === "custom" && (
                        <div className="d-flex flex-column gap-3">
                            <Input type="date" className="new_date_input form-control rounded-3" value={filters.starting} max={new Date().toLocaleDateString("en-CA")} onChange={(e) => handleInputChange(e, "starting")} />
                            <Input type="date" className="new_date_input form-control rounded-3" value={filters.ending} max={new Date().toLocaleDateString("en-CA")} onChange={(e) => handleInputChange(e, "ending")} />
                        </div>
                    )}
                    <div className="d-flex flex-wrap">

                        {filters.selectDate == 'date' && <Input type="date" className="new_date_input form-control rounded-3" value={filters.date} max={new Date().toLocaleDateString("en-CA")} onChange={(e) => handleInputChange(e, "date")} />
                        }
                        {filters.selectDate === "week" &&
                            <Input type="week" className="new_date_input form-control rounded-3" value={filters.week} max={new Date().toLocaleDateString("en-CA")} onChange={(e) => handleInputChange(e, "week")} />
                        }
                        {filters.selectDate === "month" &&
                            <Input type="month" className="new_date_input form-control rounded-3" value={filters.month} max={new Date().toLocaleDateString("en-CA")} onChange={(e) => handleInputChange(e, "month")} />
                        }
                        {timeFilter && filters.selectDate == 'date' &&
                            <Input type="time" className="mt-2 new_date_input form-control rounded-3" value={filters.time} onChange={(e) => handleInputChange(e, "time")} />
                        }
                       
                    </div>

                    <div className="d-flex gap-3 flex-wrap">
                        <CustomButton1 text='Apply' onClick={handleSave} />
                        <CustomButton1 classNamee={'button_red'} text='Reset' onClick={handleCancel} />

                    </div>


                </div>


                {/* </div> */}
            </div>
        </>
    );
}


